import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { styled } from '@mui/system';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper'; 
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import FormControl from '@mui/material/FormControl'; 
import InputLabel from '@mui/material/InputLabel';   
import Select from '@mui/material/Select';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle';  
import logoImage from './images/logo.jpg'; 
import psdfimage from './images/psdfimage.png';


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}


function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
export default class Salesrevenuedetailedreport extends Component {
	constructor(props) {
    super(props);
		
	   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	
	   const currentDate = new Date();
	     var month = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);

	
this.state = {
	fromdate:new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),fromdate1:currentDate.getFullYear() + '-' + month + '-' + '01',
	todate:Date.now(),todate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
redirect:false,pagename:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],
	 search:'',order:'desc' ,orderBy:'sin_id', SaleData:[],iop_pr_id:'',
	 openExportDialog: false,
      }	  
	 };
componentWillMount() {
	let search = window.location.href;
    let Prid = this.getParameterByName('prid', search);
	
document.title = "Isifol - Sales Revenue Detailed Report";	
if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {			
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
		  
	 let strname="Sales Revenue Detailed - Products & Services";
		   
	 this.props.parentdasCallback(
            strname+"~"
        );	
		 let fromdates = this.getParameterByName('fromdate', search);
    const todates = this.getParameterByName('todate', search);

    if (fromdates && todates) {
        this.setState({
            fromdate: dayjs(fromdates),
            fromdate1: fromdates,
            todate: dayjs(todates),
            todate1: todates
        }, () => {
            if (Prid != null) {
                this.apicall(this.state.page, this.state.rowsPerPage);
            }
        });
    } else {
        if (Prid != null) {
            this.apicall(this.state.page, this.state.rowsPerPage);
        }
    }

 
	}
	PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=34')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	

      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}	
apicall(page,rowsPerPage){
	let search = window.location.href;
    let Prid = this.getParameterByName('prid', search);
  axios.get(localStorage.getItem("ISIurl")+'ajaxsalesrevenuereport.php?action=salerevenuedetreport&iop_pr_id='+Prid+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&sin_cmp_id='+localStorage.getItem("ISIcmpid")+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  SaleData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			});
			let strname="Sales Revenue Detailed - Products & Services: "+resp.data[0].pr_code+"-"+resp.data[0].iop_description;
		   
	 this.props.parentdasCallback(
         strname+"~"
     );
     }
	 else{
		   this.setState({SaleData:[],totaldata:0});
	 }
   
    });

}

handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
} 

  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };  
  
 handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
 myChangeHandler = (event) => {
	

	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  

  this.setState({[nam]: val});

  

} 
 FromdateHandler = (date) => {
     var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
  this.setState({
        fromdate: dayjs(dateObj),
        fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}


  
  
TodateHandler = (date) => {
     var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
  this.setState({
        todate: dayjs(dateObj),
       todate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
} 


	
 handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
handleDownload = () => {
    const { SaleData } = this.state;
    const doc = new jsPDF();
	
    const imgWidth = 40;  
    const imgHeight = 12; 
    const imgX = (doc.internal.pageSize.width - imgWidth) / 2; 
    const imgY = 10;      
doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);

const firstItem = SaleData[0];
    const prCode = firstItem && firstItem.pr_code ? firstItem.pr_code : '';
    const description = firstItem && firstItem.iop_description ? firstItem.iop_description : '';
    const title = 'Sales Revenue Detailed - Products & Services: ' + prCode + ' - ' + description;
  const pageWidth = doc.internal.pageSize.width;
    const margin = 20; 
    const maxWidth = pageWidth - margin * 2;

    const titleLines = doc.splitTextToSize(title, maxWidth);

    doc.setFontSize(16);
    let currentY = imgY + imgHeight + 8;

    
    titleLines.forEach(line => {
        doc.text(line, pageWidth / 2, currentY, { align: 'center' });
        currentY += 8; 
    });

    const tableStartY = currentY + 10;


    const headers = [
        ['Trx No.','Type', 'Date', 'Name','Invoice No.', 'Unit Price',  'Qty/Hrs', 'Net', 'Cost', 'Profit', 'Profit(%)']
    ];

    const rows = SaleData.map(item => {
        return [
		item.sin_referenceno,
		'Sales Invoice',
		item.pr_code,
            item.invoicedate,
            item.cu_businessname,
            item.iop_price,
			item.totalqty,
			item.totalsaleamt,
			item.totalcostprice,
			item.profitamt,
			item.profitpercentage
        ];
    });
let totalqty_total = 0;
    let totalsaleamt_total = 0;
    let totalcostprice_total = 0;
    let profitamt_total = 0;
    let profitpercentage_total = 0;

    SaleData.forEach(item => {
        
        totalqty_total += parseFloat(item.totalqty || 0);
        totalsaleamt_total += parseFloat(item.totalsaleamt || 0);
        totalcostprice_total += parseFloat(item.totalcostprice || 0);
        profitamt_total += parseFloat(item.profitamt || 0);
       
    });

    
    rows.push([
        '', '', '', '','', 'TOTAL',
       
        totalqty_total,
        totalsaleamt_total.toFixed(2),
        totalcostprice_total.toFixed(2),
        profitamt_total.toFixed(2),
       
    ]);
     doc.autoTable({
    head: headers,
    body: rows,
    startY: tableStartY,
    theme: 'striped',
    didDrawPage: function () {
        var str = "Page " + doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.text(
            str,
            doc.internal.pageSize.width / 2,
            doc.internal.pageSize.height - 10,
            { align: "center" }
        );
    }
});

    doc.save('Salesrevenuedetailed - Products & Services.pdf');
    this.handleCloseExportDialog();
};

	
render() {
   if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  let totalqty_total = 0;
  let totalsaleamt_total = 0;
  let totalcostprice_total = 0;
  let profitamt_total = 0;
   this.state.SaleData.forEach(item => {

    totalqty_total += parseFloat(item.totalqty || 0);
    totalsaleamt_total += parseFloat(item.totalsaleamt || 0);
    totalcostprice_total += parseFloat(item.totalcostprice || 0);
    profitamt_total += parseFloat(item.profitamt || 0);
   
  });
  return (
  
  
<React.Fragment>
<div className="searchbox">
<ul>
<li>  <p> From </p>
  
 <p><LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  value={dayjs(this.state.fromdate)}
                  onChange={this.FromdateHandler}
                  format="MM/DD/YYYY"
                  className="txtbox"
				  
                />
			  </DemoContainer>
            </LocalizationProvider></p></li>
			
			  	  <li> 
<p> To </p> 
				<p>   <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  value={dayjs(this.state.todate)}
                  onChange={this.TodateHandler}
                  format="MM/DD/YYYY"
                  className="txtbox"
				 
                />
              </DemoContainer>
            </LocalizationProvider></p> </li>

	<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Calculate 
</Button>  
                              
</p>
</li>					
</ul>
</div>
<div className="addandbacbtns"> 
<p>&nbsp;</p>
  <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button>
</div>
<div className="clear"> </div>
<div className="estimatebox">
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table id="salerevenue" stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
            
		
           <TableCell>Txn No.</TableCell>
        
		<TableCell>Type</TableCell>
		<TableCell>Date</TableCell>
		<TableCell>Name</TableCell>
		<TableCell>Invoice No.</TableCell>
		<TableCell>Unit Price</TableCell>
		<TableCell>Qty/Hrs</TableCell>
		<TableCell>Net($)</TableCell>
		<TableCell>Cost($)</TableCell>
		<TableCell >Profit($)</TableCell>
		<TableCell >Profit(%)</TableCell>
          </TableRow>
        </TableHead>

 

  <TableBody>

{stableSort(this.state.SaleData, getSorting(this.state.orderBy, this.state.order)).map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
<TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.sin_referenceno}</a></TableCell>
 <TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>Sales Invoice</a></TableCell>
 <TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.invoicedate}</a></TableCell>
<TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.cu_businessname}</a></TableCell>
<TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.sin_invoiceno}</a></TableCell>
<TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{'\u200B' + parseFloat(item.iop_price || 0).toFixed(2)}</a></TableCell>
<TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.totalqty}</a></TableCell>
<TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.totalsaleamt}</a></TableCell>
<TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.totalcostprice}</a></TableCell>
<TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.profitamt}</a></TableCell>
 <TableCell><a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>{item.profitpercentage}</a></TableCell>


</TableRow>


				</React.Fragment>	
				);
					})}
	{this.state.SaleData.length > 0 && (				
			<TableRow>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>

                    <TableCell><strong>Total</strong></TableCell>
                    
                    <TableCell><strong>{totalqty_total}</strong></TableCell>
                    <TableCell><strong>{totalsaleamt_total.toFixed(2)}</strong></TableCell>
                    <TableCell><strong>{totalcostprice_total.toFixed(2)}</strong></TableCell>
                    <TableCell><strong>{profitamt_total.toFixed(2)}</strong></TableCell>
                    <TableCell></TableCell>
                 
  <TableCell></TableCell>
</TableRow>	
	)}	
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="12">No Records</TableCell>
					</TableRow>
					) }
					
					
					
 </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20,50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
  
  </div>
<Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
    <DialogTitle>Sales Revenue - Products & Services Report</DialogTitle>

    <DialogContent>
        <p>
            To generate a new report, based on the latest selection criteria 
            you've specified, choose the format you want to use. Depending on 
            the amount of data included on the report, it may take some time 
            to generate.
        </p>

        <p style={{ 
            textAlign: "center", 
            display: "flex", 
            justifyContent: "center", 
            gap: "20px" 
        }}>

            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="my-custom-excel-button"
                table="salerevenue"
                filename="Sales_Revenue_Products_Services_Report"
                sheet="Sales Revenue Report"
                buttonText=""
            />

            <img
                src={psdfimage}
                width={100}
                height={100}
                style={{ cursor: "pointer" }}
                onClick={this.handleDownload}
                alt="Download PDF"
            />

        </p>

    </DialogContent>

    <DialogActions>
        <Button 
            onClick={this.handleCloseExportDialog} 
            color="primary"
        >
            Cancel
        </Button>
    </DialogActions>

</Dialog>
</React.Fragment>
)
}
}
